import React from 'react';
import TrueImpactLevelFeedbackModal from 'shared/design-system/components/TrueImpactLevelFeedbackModal';

interface ForecastResultOneWarningModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
  initialNote: string;
  forecastIsOne: boolean;
  finalForecastIsOne: boolean;
  isInterimStage: boolean;
  indicatorName: string;
}

const ForecastResultOneWarningModal: React.FC<ForecastResultOneWarningModalProps> = ({
  open,
  onClose,
  onConfirm,
  initialNote,
  forecastIsOne,
  finalForecastIsOne,
  isInterimStage,
  indicatorName,
}) => {
  const finalLabel = isInterimStage ? 'Updated Forecast' : 'Final Results';
  const labels: string[] = [];
  if (forecastIsOne) labels.push('Forecast');
  if (finalForecastIsOne) labels.push(finalLabel);
  const fieldLabel = labels.join(' and ');

  return (
    <TrueImpactLevelFeedbackModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Save"
      initialNote={initialNote}
      placeholder={`Please explain why this indicator's ${fieldLabel} ${
        labels.length > 1 ? 'are' : 'is'
      } 1.`}
      message={
        <>
          The {fieldLabel} {labels.length > 1 ? 'are' : 'is'} set to 1 for{' '}
          <strong>{indicatorName}</strong>. Are you sure{' '}
          {labels.length > 1 ? 'these are' : 'this is'} accurate? Please provide
          your reasoning below.
        </>
      }
    />
  );
};

export default ForecastResultOneWarningModal;
